var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-select',{model:{value:(_vm.consent),callback:function ($$v) {_vm.consent=$$v},expression:"consent"}},_vm._l((_vm.consentTypes),function(item,index){return _c('vs-select-item',{key:index,attrs:{"value":item,"text":_vm.consentNames[index]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }